var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StandardLayout',{staticStyle:{"text-align":"center"}},[_c('div',[_vm._v("Micad Analytics Centre")])])}
var staticRenderFns = []

export { render, staticRenderFns }